import { MinFilter } from '../filters/min-filter';
import { FieldValidator } from '../field-validator';
import { GreaterOrEqualThanOtherFieldFilter } from '../filters/greater-or-equal-than-other-field-filter';
import { GreaterThanOtherFieldFilter } from '../filters/greater-than-other-field-filter';
import { MultipleOfFilter } from '../filters/multiple-of-filter';
import { RangeFilter } from '../filters/range-filter';

export abstract class NumberValidator extends FieldValidator<number> {
    greaterThan(otherFieldName: string) {
        this.filters.push(new GreaterThanOtherFieldFilter(otherFieldName));
        return this;
    }

    greaterOrEqualThan(otherFieldName: string) {
        this.filters.push(new GreaterOrEqualThanOtherFieldFilter(otherFieldName));
        return this;
    }

    multipleOf(multiple: number) {
        this.filters.push(new MultipleOfFilter(multiple));
        return this;
    }

    range(minValue: number, maxValue: number) {
        this.filters.push(new RangeFilter(minValue, maxValue));
        return this;
    }

    min(minValue: number) {
        this.filters.push(new MinFilter(minValue));
        return this;
    }
}
